import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import _ from 'lodash';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import styles from '../../assets/jss/pages/organizerListPageStyle';
import Button from '../../components/Button/CustomButton';
import { MEDIA_TYPE } from '../../common/Constants';
import CustomTypography from '../../components/Typography/CustomTypography';
import {
    AddIcon, RemoveIcon,
} from '../../components/Icons/Icon';
import WrapperContainer from '../../components/Container/WrapperContainer';
import ListCompanyCustomLayout from '../../components/ListCompanyCustomLayout/ListCompanyCustomLayout';
import { platform, PLATFORM } from '../../utils/getPlatform';

const useStyles = makeStyles(styles);

const OrganizerListCustomLayoutFirst = ({
    viewMode,
    companyList,
    isAuthorized,
    handleRedirectDetail,
    eventInfo,
    allProducts,
    isWeakAuth,
    customText,
    handleBrowse,
    isSearchButtonDisabled,
    addFavorite,
    customColor,
    handleAddFavorite,
}) => {
    const classes = useStyles(customColor);
    const intl = useIntl();
    const [productItem, setProductItem] = useState({});

    useEffect(() => {
        if (!_.isEmpty(allProducts)) {
            setProductItem(allProducts);
        }
    }, [allProducts]);

    const onClick = (e, companyId, value) => {
        e.stopPropagation();
        handleAddFavorite(companyId, value);
    };

    const renderIconList = (value) => (
        <>
            {value.map((item, index) => (
                <GridItem xs={12} sm={6} md={4} lg={4} key={+`${item.companyID}${index}`} className={classes.layoutFirstItem}>
                    <article
                        className={classes.layoutFirstProductItem}
                        onClick={() => handleRedirectDetail(item.companyID)}
                        style={{ cursor: isAuthorized ? 'pointer' : 'auto' }}
                    >
                        <div className={classes.layoutFirstProductThumbnail}>
                            {item.mediaType === MEDIA_TYPE.IMAGE && (
                                <img
                                    src={item.media}
                                    alt=""
                                    className={classes.layoutFirstProductItemImg}
                                />
                            )}
                            {item.mediaType === MEDIA_TYPE.AUDIO && (
                                <img
                                    src="/resources/audio_image.png"
                                    alt=""
                                    className={classes.layoutFirstProductItemIcon}
                                />
                            )}
                            {item.mediaType === MEDIA_TYPE.VIDEO && (
                                <img
                                    src="/resources/video_image.png"
                                    alt=""
                                    className={classes.layoutFirstProductItemIcon}
                                />
                            )}
                        </div>
                        <div className={classes.layoutFirstProductMeta}>
                            <div className={classes.layoutFirstProductName}>{item.name}</div>
                            <div className={classes.layoutFirstCompanyName}>
                                <CustomTypography customColor={customColor?.contents_text_color}>{item.companyName}</CustomTypography>
                            </div>
                            <div className={classes.layoutFirstCompanyType}>
                                <CustomTypography customColor={customColor?.contents_text_color}>{item.companyType}</CustomTypography>
                            </div>
                            {(isAuthorized && !eventInfo.free_exhibition && isWeakAuth === '' && addFavorite[[item.companyID]]) && (
                                <Button
                                    color="navy"
                                    className={classes.buttonAddFavorite}
                                    onClick={(e) => onClick(e, item.companyID, !addFavorite[[item.companyID]])}
                                    buttonTextColor={addFavorite[[item.companyID]] ? (customColor?.contents_text_color || '#000000de') : customColor?.button_text_color}
                                    buttonBackgroundColor={addFavorite[[item.companyID]]
                                        ? (customColor?.button_background_color?.delete_favorite_company || '#d8e2f3')
                                        : customColor?.button_background_color?.common_button}
                                >
                                    {addFavorite[[item.companyID]] && (
                                        <RemoveIcon color={customColor?.contents_text_color || '#000000de'} />
                                    )}
                                    {intl.formatMessage({ id: 'organizerPosterList.listCompany' })}
                                </Button>
                            )}
                            {(isAuthorized && !eventInfo.free_exhibition && isWeakAuth === '' && !addFavorite[[item.companyID]]) && (
                                <Button
                                    color="navy"
                                    className={classes.buttonAddFavorite}
                                    onClick={(e) => onClick(e, item.companyID, !addFavorite[[item.companyID]])}
                                    buttonTextColor={addFavorite[[item.companyID]] ? (customColor?.contents_text_color || '#000000de') : customColor?.button_text_color}
                                    buttonBackgroundColor={addFavorite[[item.companyID]]
                                        ? (customColor?.button_background_color?.delete_favorite_company || '#d8e2f3')
                                        : customColor?.button_background_color?.common_button}
                                >
                                    {!addFavorite[[item.companyID]] && (
                                        <AddIcon color={customColor?.button_text_color || '#fff'} />
                                    )}
                                    {intl.formatMessage({ id: 'organizerPosterList.listCompany' })}
                                </Button>
                            )}
                        </div>
                    </article>
                </GridItem>
            ))}
        </>
    );

    const renderTable = () => (
        <>
            {companyList.map((item, index) => (
                <GridItem key={+`${item.id}${index}`} className={classes.layoutFirstTable}>
                    <ListCompanyCustomLayout
                        isFreeExhibition={!(isAuthorized && !eventInfo.free_exhibition && isWeakAuth === '')}
                        customColor={customColor}
                        urlImg={item.image || '/resources/No_image_found.jpg'}
                        handleAddFavorite={() => handleAddFavorite(item.id, !addFavorite[[item.id]])}
                        handleViewDetail={() => handleRedirectDetail(item.id)}
                        companyName={item.full_name}
                        industryName={item.company_type}
                        content={item.description}
                        isAddFavorite={addFavorite[[item.id]]}
                        isCursor={isAuthorized}
                    />
                </GridItem>
            ))}
        </>
    );

    return (
        <>
            <WrapperContainer className={classNames({ [classes.noPadding]: platform !== PLATFORM.OTHER })}>
                <GridItem xs={12} className={classes.layoutFirst}>
                    <GridContainer className={!!viewMode && classes.containerLayoutFirst}>
                        {viewMode && !_.isEmpty(productItem.results) && renderIconList(productItem.results)}
                        {!viewMode && renderTable()}
                    </GridContainer>
                    {_.isEmpty(productItem.results) && !!viewMode && (
                        <div>
                            <CustomTypography
                                variant="h5"
                                align="center"
                                style={{ marginBottom: '8px', fontWeight: 'bold', fontSize: '20px' }}
                                customColor={eventInfo?.settings_colors_viewer?.contents_text_color}
                            >
                                {intl.formatMessage({ id: 'productManagement.noData' })}
                            </CustomTypography>
                        </div>
                    )}
                </GridItem>
            </WrapperContainer>
            {(isAuthorized && (!isWeakAuth || isWeakAuth === '')) && (
                <Box textAlign="center" mt={3} mb={2}>
                    <Button
                        color="navy"
                        onClick={() => handleBrowse()}
                        disabled={isSearchButtonDisabled}
                        round
                        size="md"
                        className={classes.buttonBig}
                        buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                        buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.common_button}
                    >
                        {customText?.button_name?.lis_companies_want_see || intl.formatMessage({ id: 'browse.listOfCompany' })}
                    </Button>
                </Box>
            )}
        </>
    );
};

OrganizerListCustomLayoutFirst.defaultProps = {
    viewMode: false,
    companyList: [],
    isAuthorized: false,
    handleRedirectDetail: () => {},
    eventInfo: {},
    allProducts: {},
    isWeakAuth: false || '',
    customText: {},
    handleBrowse: () => {},
    isSearchButtonDisabled: false,
    addFavorite: [],
    customColor: {},
    handleAddFavorite: () => {},
};

OrganizerListCustomLayoutFirst.propTypes = {
    viewMode: PropTypes.bool,
    companyList: PropTypes.oneOfType([() => null, PropTypes.array]),
    isAuthorized: PropTypes.bool,
    handleRedirectDetail: PropTypes.func,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    allProducts: PropTypes.oneOfType([() => null, PropTypes.object]),
    isWeakAuth: PropTypes.oneOfType([() => null, PropTypes.string, PropTypes.bool]),
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    handleBrowse: PropTypes.func,
    isSearchButtonDisabled: PropTypes.bool,
    addFavorite: PropTypes.oneOfType([() => null, PropTypes.array]),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    handleAddFavorite: PropTypes.func,
};

export default OrganizerListCustomLayoutFirst;
